export * from './customer-company-details-content';
